module.exports = __webpack_public_path__ + "img/ancient_of_growth_small.e9ecd3df.png";